import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Container, TextWrapper, CloudAsset, CloudWrapper, MainTextPairing } from './SpeechBubbles.styles';
import { Box } from '@components/Box';
import { JoykitColor } from '@components/themes';

type SectionVariant = 'humana' | 'purple' | 'blue';

const sectionVariantsMap: {
  [key in SectionVariant]: ColorScheme;
} = {
  humana: {
    eyebrowColor: 'humanaDark4',
    titleColor: 'neutra6',
    bodyColor: 'neutra5',
  },
  purple: {
    eyebrowColor: 'purple4',
    titleColor: 'purple5',
    bodyColor: 'purple6',
  },
  blue: {
    eyebrowColor: 'blue5',
    titleColor: 'blue6',
    bodyColor: 'blue6',
  },
};

interface SpeechBubblesProps
  extends Readonly<{
    eyebrow: string;
    title: string;
    body: string;
    variant: SectionVariant;
    imagesSrc: string;
    isHorizontal: boolean;
    titleMaxWidth?: string;
    bodyMaxWidth?: string;
    backgroundColor?: JoykitColor;
  }> {}

interface ColorScheme {
  eyebrowColor: JoykitColor;
  titleColor: JoykitColor;
  bodyColor: JoykitColor;
}

export const SpeechBubbles: React.FC<SpeechBubblesProps> = ({
  variant,
  eyebrow,
  title,
  body,
  imagesSrc,
  isHorizontal,
  titleMaxWidth,
  bodyMaxWidth,
  backgroundColor,
}) => {
  const colorScheme = sectionVariantsMap[variant];
  const { eyebrowColor, titleColor, bodyColor } = colorScheme || {};
  return (
    <Box backgroundColor={backgroundColor}>
      <Container $isHorizontal={isHorizontal} stackOnMobile centered verticalAlign="center">
        <CloudWrapper $isHorizontal={isHorizontal}>
          <CloudAsset $isHorizontal={isHorizontal} alt="speech-bubble-asset" src={imagesSrc} />
        </CloudWrapper>
        <TextWrapper $isHorizontal={isHorizontal} offset={isHorizontal ? 'one' : undefined}>
          <MainTextPairing
            alignment={isHorizontal ? 'left' : 'center'}
            eyebrow={eyebrow}
            eyebrowColor={eyebrowColor}
            eyebrowVariant="sectionEyeBrow24"
            eyebrowTagName="h2"
            title={ReactHtmlParser(title)}
            titleColor={titleColor}
            titleVariant="hed56"
            titleTagName="h2"
            maxWidth={titleMaxWidth}
            body={ReactHtmlParser(body)}
            bodyVariant="dek20"
            bodyColor={bodyColor}
            bodyMaxWidth={bodyMaxWidth}
          />
        </TextWrapper>
      </Container>
    </Box>
  );
};
